import { IPublicClientApplication } from '@azure/msal-browser';
import { NominationProgress } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getNominationProgress, updateNominationProgress } from './index';

export const createNominationProgressApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getNominationProgress: (instance: IPublicClientApplication, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getNominationProgress(fetchContext, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getNominationProgress', isInFlight);
    },
  ),
  updateNominationProgress: (instance: IPublicClientApplication, nominationId: number, nominationProgress: NominationProgress) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateNominationProgress(fetchContext, nominationId, nominationProgress, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateNominationProgress', isInFlight);
    },
  ),
});
